module.exports = __webpack_public_path__ + "img/1F1F5-1F1FE.a2887e88.svg";